import { getLocationPermission } from './getLocationPermission';
import { requestLocationPermission } from './requestLocationPermission';

const debug = require('debug')('tca:kit:utilities:UserLocation');

export const getUserLocation = async (): Promise<{
  latitude: number;
  longitude: number;
}> => {
  try {
    // First check current permission status
    const permission = await getLocationPermission();
    debug(`Location permission check result: ${permission}`);

    if (permission === 'denied') {
      // If permission is denied (first time asking), request it
      const requestResult = await requestLocationPermission();
      debug(
        `Location permission request result: ${JSON.stringify(requestResult)}`
      );

      if (requestResult !== 'granted') {
        throw new Error('Location permission denied');
      }
    } else if (permission !== 'granted') {
      throw new Error('Location permission not granted');
    }

    const location = await new Promise<GeolocationPosition>(
      (resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0,
        });
      }
    );

    debug(`Got location: ${JSON.stringify(location)}`);

    return {
      latitude: location.coords.latitude,
      longitude: location.coords.longitude,
    };
  } catch (error) {
    debug(`Error getting location: ${JSON.stringify(error)}`);
    throw error;
  }
};
